import React, { useEffect, useState } from 'react';
import './stops.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import {
  getBoundsFromPoints, getPaginationOpts, getPointData, getPointOptions, getResponseError, isCoordinatePair,
  responseLogWithNotification,
  useFilterForm,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getStopsData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import { deleteStops, loadStopsByIdClear, loadStopsList } from '../actions';
import { STOPS_MODULE } from '../../../configs/moduleNames';
import YMap from '../../../components/base/Map/YMap';
import StopsList from './StopsList';
import StopsForm from './StopsForm';
import { showGlobalConfirm } from '../../System/actions';
import { errorNotification, successNotification, warningNotification } from '../../Notifications/notificationDecorator';

export default function StopsPage() {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [selected, setSelected] = useState(false);
  const [mapInstance, setMapInstance] = useState(null);
  const [clusterer, setClusterer] = useState([]);
  const [geoObjects, setGeoObjects] = useState([]);
  const { updatePeriod } = useSelector(getSystemData);
  const store = useStore();
  const {
    stopsListMeta,
    stopsList,
    loadingStopsList,
    loadingCurrentStops,
    loadingCreateStops,
    loadingEditStopsById,
    loadingDeleteStops,
    loadingExportStops,
    loadingImportStops,
  } = useSelector(getStopsData);
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[STOPS_MODULE].listMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
    };
    const p1 = dispatch(loadStopsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const { getValues, control } = useFilterForm({}, loadData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  const selectedElement = stopsList.find(item => item.stop_id === selected);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    let clusterer = null;
    const selectedElement = stopsList.find(item => item.stop_id === selected);
    if (selected && !selectedElement) {
      setSelected(null);
    }
    if (mapInstance) {
      const markers = selected ? [selectedElement] : stopsList;
      clusterer = createClusterer(markers);
      if (clusterer) {
        setClusterer(clusterer);
        mapInstance.geoObjects.add(clusterer);
        const b = clusterer.getBounds();
        if (b) {
          mapInstance.setBounds(b, {
            checkZoomRange: true,
          });
        }
      }
    }
    return () => {
      if (mapInstance?.geoObjects && clusterer) {
        mapInstance.geoObjects.remove(clusterer);
      }
    };
  }, [selected, stopsList, mapInstance, showForm]);

  const createClusterer = list => {
    const validList = (list || []).filter(item => isCoordinatePair(getCoordinatesFromStop(item)));
    if (!validList.length) {
      setGeoObjects([]);
      return null;
    }
    const clusterer = new window.ymaps.Clusterer({
      // Макет метки кластера pieChart.
      clusterIconLayout: 'default#pieChart',
      // Радиус диаграммы в пикселях.
      clusterIconPieChartRadius: 25,
      // Радиус центральной части макета.
      clusterIconPieChartCoreRadius: 10,
      // Ширина линий-разделителей секторов и внешней обводки диаграммы.
      clusterIconPieChartStrokeWidth: 2,
      // // Определяет наличие поля balloon.
      // hasBalloon: false

      // preset: 'islands#invertedVioletClusterIcons',
      // groupByCoordinates: false,
      clusterDisableClickZoom: true,
      clusterHideIconOnBalloonOpen: false,
      geoObjectHideIconOnBalloonOpen: false,
    });
    const gO = [];
    for (let i = 0, len = validList.length; i < len; i++) {
      const pointData = getPointData(validList[i]);
      const c = getCoordinatesFromStop(validList[i]);

      gO.push(new window.ymaps.Placemark(c, pointData, getPointOptions(validList[i], false)));
    }

    clusterer.options.set({
      gridSize: 80,
      clusterDisableClickZoom: true,
    });
    setGeoObjects(gO);
    clusterer.add(gO);
    return clusterer;
  };

  const handleClose = () => {
    clearCurrentState();
    setShowForm(false);
    setSelected(null);
  };

  const handleCreate = () => {
    if (!mapInstance) {
      warningNotification('Карта еще не загружена', 'Попробуйте чуть позже');
      return;
    }
    clearCurrentState();
    setShowForm(true);
    setSelected(null);
  };

  const handleSelect = (item, isEdit = false) => () => {
    if (selected === item.stop_id && !isEdit) {
      setSelected(null);
      return;
    }
    if (selected !== item.stop_id) {
      setSelected(item.stop_id);
      if (mapInstance && item?.area?.coordinates?.length > 0) {
        const b = getBoundsFromPoints(item.area.coordinates);
        if (b) {
          mapInstance.setBounds(b);
        }
      }
    }
  };

  const handleEdit = item => event => {
    if (!mapInstance) {
      warningNotification('Карта еще не загружена', 'Попробуйте чуть позже');
      return;
    }
    handleSelect(item, true)();
    setShowForm(true);
    event.stopPropagation();
    event.preventDefault();
  };

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление зоны "${item.name || 'Без имени'}"`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteStops(item.stop_id)).then(() => {
        if (selected === item.stop_id) {
          setSelected(null);
        }
        loadData();
        successNotification('Удаление зоны', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление зоны', getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const clearCurrentState = () => {
    dispatch(loadStopsByIdClear()).catch(responseLogWithNotification);
  };

  const getCoordinatesFromStop = item => (item?.location?.geometry?.coordinates?.length
    ? item?.location?.geometry.coordinates : []);
  return (
    <div className="page application-page">
      <Loader loading={loadingStopsList || loadingCurrentStops || loadingDeleteStops || loadingCreateStops || loadingEditStopsById || loadingExportStops || loadingImportStops} />
      <div className="page-content-wrapper">
        <div className="stops-columns">
          {!showForm ? (
            <StopsList
              handleCreate={handleCreate}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              handleSelect={handleSelect}
              loadData={loadData}
              selected={selected}
              stopsListMeta={stopsListMeta}
              stopsList={stopsList}
              control={control}
            />
          ) : false}
          {showForm
            ? (
              <StopsForm
                handleClose={handleClose}
                loadData={loadData}
                stop={selectedElement}
                mapInstance={mapInstance}
                geoObjects={geoObjects}
              />
            )
            : false}
          <div className="map-columns card">
            <YMap
              classNames="stops-map"
              setMapInstance={i => setMapInstance(i)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
